import { GET_USERDETAILS_BY_USERID } from "../actions/types";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_USERDETAILS_BY_USERID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getUserDetailsByUserId.js